type nativeJSType = {
  name: string
  method?: Function | null
  onSuccess?: string | null
  onError?: string | null
}

export const getWindow = () => {
  if (window.webkit) {
    return window?.webkit?.messageHandlers
  } else {
    return window
  }
}

const nativeJSComm = (
  nativeJSMethod: nativeJSType,
  onSuccessMethod?: Function,
  onErrorMethod?: Function,
  data = {},
) => {
  /**
   *
   * This commented piece of code works on Android but not on iOS.
   * const newMessage = `{"data":${JSON.stringify(data)}, "module":"JPB","event":${nativeJSMethod.name}, "version":""}`
   *
   */

  const message = {
    data: data,
    module: 'JPB',
    event: nativeJSMethod.name,
    version: '',
    onSuccess: nativeJSMethod.onSuccess,
    onError: nativeJSMethod.onError,
  }

  const newMessage = JSON.stringify(message)
  console.log(newMessage, "received message via js bridge...::")
  /**
   * This block is required in order to add the callback methods on to the window object.
   */
  if (onSuccessMethod) {
    window[nativeJSMethod.onSuccess] = onSuccessMethod
  }
  if (onErrorMethod) {
    window[nativeJSMethod.onError] = onErrorMethod
  }

  getWindow()?.AepsWebViewInterface?.postMessage(newMessage)
}

const nativeJSMapper = {
  getAgentInfo: { name: 'GET_AGENT_INFO', onSuccess: 'onAgentInfoCaptured', onError: null },
  closeWebView: { name: 'CLOSE_WEB_VIEW' },
  scanFingerPrint: {
    name: 'SCAN_FINGER_PRINT',
    onSuccess: 'onFingerprintScanSuccess',
    onError: 'onFingerprintScanError',
  },
  installBiometricApp: { name: 'INSTALL_BIOMETRIC_APP' },
  enableScreenShot: { name: 'ENABLE_SCREENSHOT' },
  disableScreenshot: { name: 'DISABLE_SCREENSHOT' },
  getAppInfo: { name: 'GET_APP_INFO', onSuccess: 'onAppInfoCaptured', onError: null },
  resetBcSession: { name: 'RESET_BC_SESSION' },
  getAppType: { name: 'GET_APP_TYPE', onSuccess: 'onAppTypeRecived', onError: null },
  downloadReceipt: { name: 'DOWNLOAD_RECEIPT', onSuccess: 'onDownloadSuccess', onError: 'onDownloadError' },
  
  formatFingerPrintData: {
    name: 'FORMAT_FINGERPRINT_DATA',
    onSuccess: 'onFingerprintDataFormated',
  },
  QrScanner: {
    name: 'SCAN_QR',
    onSuccess: 'onScannerDataFormated',
    onError: 'onScanError'
  },

}

export { nativeJSComm, nativeJSMapper }
